// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 523020892
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Cpt } from './models/common/cpt';

@Injectable({
  providedIn: 'root',
})
export class CptApiService {
  constructor(protected http: HttpClient) {}

  getCptByCode(cptCode: string): Observable<Cpt> {
    const url = environment.chiliSauceApiRoot + `/api/Cpt/${cptCode}`;
    return this.http.get<Cpt>(url);
  }
}
